export const getInitials = (name) => {
    // default params only cover `undefined`, not a `null` name - a record
    // with the field explicitly null still reached .trim() on null and threw.
    const words = (name || "").trim().split(/\s+/);

    if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
    }

    if (words[0]?.length >= 2) {
        return words[0].slice(0, 2).toUpperCase();
    }

    return words[0]?.toUpperCase() || "??";
};